/**
 * 二级品类 chips(品类详情页)。「全部」(null)+ 各 L2;纯前端过滤(不 refetch)。
 */
import type { CategoryNode } from '@/api/guide';
import { cn } from '@/lib/cn';

interface SubcategoryChipsProps {
  children: CategoryNode[];
  selectedL2: string | null;
  onSelect: (id: string | null) => void;
}

export function SubcategoryChips({ children, selectedL2, onSelect }: SubcategoryChipsProps) {
  return (
    <div className="row gap-2 wrap mb-8">
      <button
        type="button"
        className={cn('tag', selectedL2 === null && 'active')}
        style={{ border: 'none' }}
        onClick={() => onSelect(null)}
      >
        全部
      </button>
      {children.map((c) => (
        <button
          key={c.id}
          type="button"
          className={cn('tag', selectedL2 === c.id && 'active')}
          style={{ border: 'none' }}
          onClick={() => onSelect(c.id ?? null)}
        >
          {c.name ?? '子类'}
        </button>
      ))}
    </div>
  );
}
